export default [
  {
    path: '/',
    name: 'front-home',
    component: () => import('@/views/frontend/components/pages/Main.vue'),
    meta: {
      layout: 'frontend',
      pageTitle: 'Главная',
      resource: 'Auth',
    },
  },
  {
    path: '/packages',
    name: 'packages',
    component: () => import('@/views/frontend/components/pages/Packages.vue'),
    meta: {
      layout: 'frontend',
      pageTitle: 'Пакеты',
      resource: 'Auth',
    },
  },
]
